export default __webpack_public_path__ + "static/media/menu-task-manager.1a4c5d09.svg";